<template>
  <PageWrapper :isLoading="isLoading" hasFilters @submitFilters="setPageNumberAndGetAllOrders"
    v-if="$can('GetAll', 'Order')">
    <template #title> لیست سفارشات ثبت شده </template>
    <template #filters>
      <SearchInput class="filters-width w-24" inputId="userFullname" inputLabel="جستجوی نام" inputPlaceholder="رضا..."
        v-model.trim="ordersListFilters.userFullname" @enter="setPageNumberAndGetAllOrders"></SearchInput>
      <SearchInput class="filters-width w-24" inputId="userMobile" inputLabel="جستجوی موبایل" inputPlaceholder="09..."
        v-model.trim="ordersListFilters.userMobile" @enter="setPageNumberAndGetAllOrders"></SearchInput>
      <SearchInput class="filters-width w-24" inputId="orderId" inputLabel="جستجوی شناسه سفارش" inputPlaceholder="21244"
        v-model.trim="ordersListFilters.orderId" @enter="setPageNumberAndGetAllOrders"></SearchInput>
      <SearchInput class="filters-width w-24" inputId="description" inputLabel="جستجوی توضیحات سفارش"
        inputPlaceholder="بابت شارز کیف پول" v-model.trim="ordersListFilters.description"
        @enter="setPageNumberAndGetAllOrders"></SearchInput>
      <UserPicker v-if="!userIdFilter" class="w-24 filters-width" @getUser="setUserFilter"></UserPicker>
      <OrderStatusPicker v-model="ordersListFilters.status" class="w-24 filters-width"></OrderStatusPicker>
      <CustomDatePicker class="w-24 filters-width" inputId="createDate" @getSelectedDate="setCreateDateFilter"
        inputLabel="تاریخ اتمام تخفیف" inputPlaceholder="1403/06/05"></CustomDatePicker>
    </template>
    <CustomTable v-if="ordersList" :pageNumber="ordersListFilters.pageNumber" :count="ordersListFilters.count"
      :totalCount="totalCount" :tableColumns="tableColumns" :tableItems="ordersList" @changePage="changePage">
      <template #status="data">
        <BBadge :variant="handleStatusChipColor(data.item.status)" style="white-space: nowrap">
          {{ orderStatuses[data.item.status] }}
        </BBadge>
      </template>
      <template #userInfo="data">
        <b-link :to="`/users/${data.item.userInfo.userId}`" style="white-space: nowrap">
          {{ data.item.userInfo.fullName }}
        </b-link>
      </template>
      <template #description="data">
        <span style="white-space: nowrap">
          {{ data.item.description }}
        </span>
      </template>
      <template #sumPrice="data">
        <span style="white-space: nowrap">
          {{
            data.item.sumPrice
              ? Intl.NumberFormat("en-US").format(data.item.sumPrice) + " تومان"
              : "-"
          }}
        </span>
      </template>
      <template #sumPriceAfterDiscount="data">
        <span style="white-space: nowrap">
          {{
            data.item.sumPriceAfterDiscount
              ? Intl.NumberFormat("en-US").format(
                data.item.sumPriceAfterDiscount
              ) + " تومان"
              : "-"
          }}
        </span>
      </template>
      <template #createDate="data">
        <div style="white-space: nowrap">
          {{ new Date(data.item.createDate).toLocaleDateString("fa-IR") }}
          -
          {{
            new Date(data.item.createDate).toLocaleTimeString("fa-IR", {
              hour: "2-digit",
              minute: "2-digit",
            })
          }}
        </div>
      </template>
      <template #actions="data">
        <b-link :to="`/orders/${data.item.orderId}`">
          <feather-icon class="text-primary" icon="EyeIcon" size="20" />
        </b-link>
      </template>
    </CustomTable>
  </PageWrapper>
</template>
<script>
export default {
  watch: {
    userIdFilter: {
      immediate: true,
      handler(val) {
        if (val) {
          this.ordersListFilters.userId = val;
        }
      },
    },
  },
  props: {
    userIdFilter: {
      type: [Number, String],
      required: false,
      default: null,
    },
  },
  mounted() {
    this.getAllOrdersForAdmin();
  },
  data() {
    return {
      ordersListFilters: {
        pageNumber: 1,
        count: 10,
        searchCommand: null,
        status: null,
        userId: null,
        courseId: null,
        lessonId: null,
        userMobile: null,
        userFullname: null,
        createDate: null,
        description: null,
        sumPrice: null,
        orderId: null,
      },
      isLoading: false,

      totalCount: null,
      ordersList: null,
      orderStatuses: {
        1: "ثبت شده",
        2: "پرداخت شده",
        3: "ارسال شده",
        4: "تحویل شده",
        5: "کنسل شده",
        6: "پرداخت شده توسط ادمین",
        7: "در انتظار پرداخت",
        8: "لغو شده",
        9: "لغو شده توسط سیستم",
      },
      tableColumns: [
        {
          label: "شناسه سفارش",
          key: "orderId",
        },
        {
          label: "وضعیت سفارش",
          key: "status",
        },
        {
          label: "کاربر",
          key: "userInfo",
        },
        {
          label: "مبلغ سفارش",
          key: "sumPrice",
        },
        {
          label: "مبلغ سفارش بعد از تخفیف",
          key: "sumPriceAfterDiscount",
        },
        {
          label: "تاریخ ثبت سفارش",
          key: "createDate",
        },
        {
          label: "توضیحات سفارش",
          key: "description",
        },
        {
          label: "عملیات",
          key: "actions",
        },
      ],
    };
  },
  methods: {
    setCreateDateFilter(createDate) {
      if (createDate) {
        this.ordersListFilters.createDate = new Date(createDate).toISOString();
      } else {
        this.ordersListFilters.createDate = null;
      }
    },
    changePage(pageNumber) {
      this.ordersListFilters.pageNumber = pageNumber;
      this.getAllOrdersForAdmin();
    },
    setUserFilter(userId) {
      this.ordersListFilters.userId = userId;
    },
    handleStatusChipColor(status) {
      switch (status) {
        case 1:
          return "warning";
        case 2:
          return "success";
        case 3:
          return "success";
        case 4:
          return "success";
        case 5:
          return "danger";
        case 6:
          return "success";
        case 7:
          return "warning";
        case 8:
          return "danger";
        case 9:
          return "danger";
      }
    },
    setPageNumberAndGetAllOrders() {
      this.ordersListFilters.pageNumber = 1;
      this.getAllOrdersForAdmin();
    },
    async getAllOrdersForAdmin() {
      try {
        this.isLoading = true;
        let _this = this;
        let getAllOrders = new GetAllOrders(_this);
        getAllOrders.setRequestParamDataObj(_this.ordersListFilters);
        await getAllOrders.fetch(function (response) {
          if (response.isSuccess) {
            _this.totalCount = response.data.ordersCount;
            _this.ordersList = response.data.orders;
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  computed: {
    pageNumber() {
      return this.ordersListFilters.pageNumber;
    },
  },
  components: {
    BLink,
    BBadge,
    UserPicker,
    PageWrapper,
    SearchInput,
    OrderStatusPicker,
    CustomDatePicker,
    CustomTable,
  },
};
import { BLink, BBadge } from "bootstrap-vue";
import { GetAllOrders } from "@/libs/Api/Order";
import PageWrapper from "@/views/components/Utils/PageWrapper.vue";
import SearchInput from "@/views/components/Utils/SearchInput.vue";
import OrderStatusPicker from "@/views/components/Orders/OrderStatusPicker.vue";
import UserPicker from "@/views/components/Users/UserPicker.vue";
import CustomDatePicker from "@/views/components/Utils/CustomDatePicker.vue";
import CustomTable from "@/views/components/Utils/CustomTable.vue";
</script>
